import ServiceBase from '../../ServiceBase';
import marketAnomalyProxy from './../../../proxies/market/market-in-depth/MarketAnomalyProxy';

class MarketAnomalyService extends ServiceBase {
  getListAnomaly(params) {
    return this.applyMemoryCache('MarketAnomalyService.getListAnomaly', params)(
      () => marketAnomalyProxy.getListAnomaly(params),
    );
  }
}

const marketAnomalyService = new MarketAnomalyService();
export default marketAnomalyService;
